import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { useEffect } from 'react'
import {
  BrowserRouter,
  useRoutes
} from 'react-router-dom'
import { Analytics } from '@vercel/analytics/react'

import { ErrorBoundary } from './components/error-boundary'
import routes from './router'
import { logger } from './utils/logger'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      onError: (error: unknown): void => {
        logger.logError(error instanceof Error ? error : new Error(String(error)), {
          type: 'react_query_error',
          source: 'query'
        })
      }
    },
    mutations: {
      onError: (error: unknown): void => {
        logger.logError(error instanceof Error ? error : new Error(String(error)), {
          type: 'react_query_error',
          source: 'mutation'
        })
      }
    }
  }
})

export function App(): JSX.Element {
  const content = useRoutes(routes)
  return <>{content}</>
}

export function WrappedApp(): JSX.Element {
  useEffect(() => {
    if (import.meta.env.MODE !== 'development' && window.newrelic) {
      logger.setCustomAttribute('environment', import.meta.env.MODE || 'production')
      logger.addPageAction('app_initialized', {
        timestamp: new Date().toISOString()
      })
    }
  }, [])

  return (
    <ErrorBoundary>
      <BrowserRouter>
        <QueryClientProvider client={queryClient}>
          <App />
          <Analytics/>
        </QueryClientProvider>
      </BrowserRouter>
    </ErrorBoundary>
  )
}
